export const spacing = {
  "space-0": { px: 0, rem: 0 },
  "space-025": { px: 1, rem: 0.0625 },
  "space-05": { px: 2, rem: 0.125 },
  "space-1": { px: 4, rem: 0.25 },
  "space-1-5": { px: 6, rem: 0.375 },
  "space-2": { px: 8, rem: 0.5 },
  "space-2-5": { px: 10, rem: 0.625 },
  "space-3": { px: 12, rem: 0.75 },
  "space-3-5": { px: 14, rem: 0.875 },
  "space-4": { px: 16, rem: 1 },
  "space-5": { px: 20, rem: 1.25 },
  "space-6": { px: 24, rem: 1.5 },
  "space-7": { px: 28, rem: 1.75 },
  "space-8": { px: 32, rem: 2 },
  "space-9": { px: 36, rem: 2.25 },
  "space-10": { px: 40, rem: 2.5 },
  "space-12": { px: 48, rem: 3 },
  "space-16": { px: 64, rem: 4 },
  "space-20": { px: 80, rem: 5 },
  "space-24": { px: 96, rem: 6 },
  "space-28": { px: 112, rem: 7 },
  "space-32": { px: 128, rem: 8 },
  "space-46": { px: 184, rem: 11.5 },
};

export type CascadiaSpacingTypes = typeof spacing;
export type CascadiaSpacing = keyof CascadiaSpacingTypes;
